















import { Component, Prop, Vue } from 'vue-property-decorator';
import moment from 'moment';

import { ListModel } from '@/models/list-model';
import { ListModelUtil } from '@/model-utils/list-model-util';

@Component({})
export default class ListCardSmallWide extends Vue {
  @Prop(ListModel) public list!: ListModel;
}
